import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import api from '../api';
import { useLanguage } from '../LanguageContext';
import './PageShell.css';
import './Notifications.css';

const typeIcon = { reply: '💬', review: '⭐', bid: '💰', task: '📋', system: '📢' };

function timeAgo(d, language) {
  const diff = (Date.now() - new Date(d)) / 1000;
  const isZh = language === 'zh';
  if (diff < 60) return isZh ? '刚刚' : 'Just now';
  if (diff < 3600) return isZh ? `${Math.floor(diff / 60)}分钟前` : `${Math.floor(diff / 60)}m ago`;
  if (diff < 86400) return isZh ? `${Math.floor(diff / 3600)}小时前` : `${Math.floor(diff / 3600)}h ago`;
  return new Date(d).toLocaleDateString(isZh ? 'zh-CN' : 'en-US');
}

export default function Notifications() {
  const { language } = useLanguage();
  const notificationLocale = language;
  const text = language === 'zh' ? {
    loading: '加载中...',
    title: '消息通知',
    unread: count => `${count} 条未读`,
    readAll: '全部已读',
    empty: '暂无通知',
    view: '查看',
  } : {
    loading: 'Loading...',
    title: 'Notifications',
    unread: count => `${count} unread`,
    readAll: 'Mark all as read',
    empty: 'No notifications',
    view: 'View',
  };
  const [items, setItems] = useState([]);
  const [unread, setUnread] = useState(0);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    setLoading(true);
    api.get(`/notifications?locale=${notificationLocale}`).then(res => {
      setItems(res.data.items);
      setUnread(res.data.unread);
    }).finally(() => setLoading(false));
  }, [notificationLocale]);

  const markAllRead = async () => {
    await api.put('/notifications/read-all');
    setItems(items.map(i => ({ ...i, is_read: 1 })));
    setUnread(0);
  };

  const markRead = async (id) => {
    await api.put(`/notifications/${id}/read`);
    setItems(items.map(i => i.id === id ? { ...i, is_read: 1 } : i));
    setUnread(u => Math.max(0, u - 1));
  };

  if (loading) return <div className="loading">{text.loading}</div>;

  return (
    <div className="page-shell-page notifications-page">
      <div className="container" style={{ maxWidth: 720, paddingTop: 32, paddingBottom: 48 }}>
      <div className="page-header" style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
        <div>
          <h1>{text.title}</h1>
          {unread > 0 && <p>{text.unread(unread)}</p>}
        </div>
        {unread > 0 && (
          <button className="btn btn-outline btn-sm" onClick={markAllRead}>{text.readAll}</button>
        )}
      </div>

      <div className="card" style={{ padding: 0, overflow: 'hidden' }}>
        {items.length === 0 ? (
          <div style={{ padding: '48px 24px', textAlign: 'center', color: '#9ca3af' }}>
            <div style={{ fontSize: 40, marginBottom: 12 }}>🔔</div>
            <p>{text.empty}</p>
          </div>
        ) : (
          items.map(item => (
            <div
              key={item.id}
              className={`notif-item ${item.is_read ? '' : 'unread'}`}
              onClick={() => !item.is_read && markRead(item.id)}
            >
              <div className="notif-icon">{typeIcon[item.type] || '📢'}</div>
              <div className="notif-body">
                <div className="notif-title">{item.title}</div>
                {item.content && <div className="notif-content">{item.content}</div>}
                <div className="notif-time">{timeAgo(item.created_at, language)}</div>
              </div>
              {item.link && (
                <Link to={item.link} className="btn btn-outline btn-sm" onClick={e => e.stopPropagation()}>
                  {text.view}
                </Link>
              )}
              {!item.is_read && <span className="unread-dot" />}
            </div>
          ))
        )}
      </div>
    </div>
  </div>
  );
}
